import React from "react";

import { useTranslation } from "utils";

import { SoilSightMarginChart, Svg } from "components";

// The hero is static. We hardcode 10 years to match the illustration and subtitle copy, not the model.
const HERO_FORECAST_YEARS = 10;

export const PreLoginHeroGraphic = () => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="soilsight-pre-login__hero-graphic">
      <Svg
        svgName="soilsight-pre-login/hero-blob-left"
        width={265}
        height={249}
        className="soilsight-pre-login__hero-blob soilsight-pre-login__hero-blob--left"
      />
      <Svg
        svgName="soilsight-pre-login/hero-blob-right"
        width={271}
        height={258}
        className="soilsight-pre-login__hero-blob soilsight-pre-login__hero-blob--right"
      />
      <SoilSightMarginChart
        className="soilsight-pre-login__hero-graphic-body"
        caption={t("preLogin.landing.hero.costTitle")}
        captionIconName="tabler/wallet"
        calloutValue={t("preLogin.landing.hero.costValue")}
        calloutDescription={t("preLogin.calloutDescription", { count: HERO_FORECAST_YEARS })}
        chartLabel={t("preLogin.landing.hero.visualAlt")}
        legend={{ baseline: t("preLogin.landing.hero.legendBaseline"), change: t("preLogin.landing.hero.legendChange") }}
      />
    </div>
  );
};
